// (c) chaehongee. Confidential and proprietary.

import { createContext, useContext, useState, type ReactNode } from 'react'

export interface MaskActions {
    exportMask?: () => Promise<Blob | null>
    exportFramedImageWithUpload?: () => Promise<{ node: any; commit: any } | null>
    resetMask?: () => void
    setBrushEnabled?: (v: boolean) => void
}

const MaskActionsContext = createContext<MaskActions>({})
const SetMaskActionsContext = createContext<((a: MaskActions) => void) | null>(null)

export function MaskProvider({ children }: { children: ReactNode }) {
    const [actions, setActions] = useState<MaskActions>({})
    return (
        <SetMaskActionsContext.Provider value={setActions}>
            <MaskActionsContext.Provider value={actions}>
                {children}
            </MaskActionsContext.Provider>
        </SetMaskActionsContext.Provider>
    )
}

export function useMaskActions(): MaskActions {
    return useContext(MaskActionsContext)
}

export function useSetMaskActions(): (a: MaskActions) => void {
    const setter = useContext(SetMaskActionsContext)
    if (!setter) return () => { }
    return setter
}


